module.exports = require('./lib/_stream_writable.js');



//////////////////
// WEBPACK FOOTER
// ./node_modules/readable-stream/writable-browser.js
// module id = 103
// module chunks = 0